import React from 'react';
import Footer from "../../navigation/footerContainer";
import BuyerDashboardContainer from './buyerDashboard'

export default function BuyerDashboardPage(){

    
    return(
        <>
            <BuyerDashboardContainer />
            <Footer />
        </>
       
    )
}